var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgHeartOutline = function SvgHeartOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.364 2.48a6.198 6.198 0 016.806 1.365c.58.585 1.04 1.28 1.354 2.043a6.342 6.342 0 01-1.354 6.864L12 22l-9.17-9.248A6.325 6.325 0 011 8.298c0-1.67.658-3.272 1.83-4.453a6.218 6.218 0 014.415-1.844c1.656 0 3.245.663 4.416 1.844l.339.342.339-.342a6.24 6.24 0 012.025-1.365zm2.39 1.457a4.291 4.291 0 00-3.057 1.278L12.68 6.242H11.32l-1.018-1.027a4.305 4.305 0 00-3.057-1.277c-1.147 0-2.247.46-3.057 1.277A4.38 4.38 0 002.92 8.298a4.38 4.38 0 001.267 3.084L12 19.26l7.812-7.878a4.39 4.39 0 000-6.166 4.291 4.291 0 00-3.058-1.278z",
    fill: "#fff"
  })));
};
export default SvgHeartOutline;